import { render, staticRenderFns } from "./RecommendedContent.vue?vue&type=template&id=8eb01026&scoped=true"
import script from "./RecommendedContent.vue?vue&type=script&lang=js"
export * from "./RecommendedContent.vue?vue&type=script&lang=js"
import style0 from "./RecommendedContent.vue?vue&type=style&index=0&id=8eb01026&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb01026",
  null
  
)

export default component.exports